import { Carousel } from "../components/Carousel";
import { DocIcon } from "../components/icons";
import { img } from "../lib/media";
import { comiteSlides, activismoSlides, docs } from "../data/content";

export function ActivismoSection() {
	return (
		<section className="section" id="activismo">
			<div className="content-wrap reveal">
				<div className="section__label">Activismo y UAM</div>
				<h2 className="section__heading">Compromiso con la justicia social.</h2>
				<div className="body-text">
					<p>
						En su tiempo en la UAM, Stefanny destacó inmediatamente por su
						compromiso con la justicia social y su capacidad para organizar y
						movilizar a sus compañeros en torno a diversas causas. Cofundó el
						Comité Feminista UAM, donde se esforzó por implementar sus convicciones
						de lucha, equidad y defensa del feminismo. Fue una figura reconocida
						dentro de la universidad al ingresar desde sus primeros semestres al
						Órgano Colegiado, hasta el 2021, cuando renunció a su puesto como
						coordinadora estudiantil después de casi 5 años. Durante esos años
						estuvo involucrada de forma cercana con la implementación o
						modificación de las leyes estudiantiles
						<sup>
							<a href="#ref2">[2]</a>
						</sup>
						. Estudió la maestría en Comunicación y Política en UAM Xochimilco.
					</p>
				</div>
			</div>

			<div className="content-wrap--wide reveal">
				<div className="side-img">
					<div className="side-img__img">
						<img src={img("comite.jpg")} alt="Comité Feminista UAM" />
					</div>
					<div className="side-img__text">
						<div className="side-img__label">Comité Feminista UAM Xochimilco</div>
						<h3 className="side-img__heading">Un pilar de la lucha estudiantil.</h3>
						<div className="side-img__body">
							<p>
								Se encargó de organizar múltiples eventos, talleres y charlas en
								favor de la equidad de género y la lucha contra la violencia de
								género, posicionando al colectivo como uno de los más activos y
								reconocidos dentro de la UAM.
							</p>
							<p>
								Hoy el colectivo sigue activo con nuevas incorporaciones de
								estudiantes que buscan continuar la lucha en el cubículo Stefanny
								Daniela Mora Nieto, en su honor — un pilar de la lucha estudiantil
								no solo en la UAM, sino en la Ciudad de México.
							</p>
						</div>
					</div>
				</div>
			</div>

			<div className="content-wrap--wide">
				<Carousel slides={comiteSlides} title="Comité Feminista" />
				<Carousel slides={activismoSlides} title="En las calles" />
			</div>

			<div className="content-wrap reveal">
				<div className="section__label">Documentos</div>
				<p className="section__intro">
					Algunos documentos de la UAM donde figura Stefanny como parte del
					colegiado académico.
				</p>
			</div>
			<div className="content-wrap--wide">
				<div className="doc-grid">
					{docs.map((d, i) => (
						<a
							className="doc-card reveal"
							href={d.href}
							target="_blank"
							rel="noopener noreferrer"
							key={i}
						>
							<div className="doc-card__icon">
								<DocIcon />
							</div>
							<div>
								<div className="doc-card__type">{d.type}</div>
								<div className="doc-card__title">{d.title}</div>
								<div className="doc-card__meta">{d.meta} · PDF</div>
							</div>
						</a>
					))}
				</div>
			</div>
		</section>
	);
}
